module.exports = __webpack_public_path__ + "static/assets/74af5393beb64d092e7ecc033d89ce4d.gif";